import React, { useState, useEffect } from 'react';
import { storage } from '../firebaseConfig'; 
import { ref, getDownloadURL } from 'firebase/storage';

function AccountIcon({ profileImageUrl, width = '35px', height = '35px', border = false }) {
    const [downloadableUrl, setDownloadableUrl] = useState(null);
    const numericWidth = parseInt(width, 10); 
    const borderSize = border ? `${numericWidth * 0.04}px` : '0px'; // Lasketaan 4% kuvan leveydestä
   
    const styles = {
        Icon: {
          color: '#ffffff',
          fill: '#ffffff',
          fontSize: '40px',
          width: width,
          height: height,
          alignItems: 'center',
          justifyContent: 'center',
        },
        Image: {
          width: width, 
          height: height, 
          borderRadius: '50%', 
          objectFit: 'cover',
          border: `${borderSize} solid white`
        }
    };
   
    const IconComponent = () => (
        <svg style={styles.Icon} viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0z"></path>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z"></path>
        </svg>
    );
   
    useEffect(() => {
        if (profileImageUrl && profileImageUrl !== 'undefined') {
          setDownloadableUrl(profileImageUrl);
        }
    }, [profileImageUrl]);

    return (
        downloadableUrl ? <img src={downloadableUrl} alt="Profiilikuva" style={styles.Image} /> : <IconComponent style={styles.Icon} />
    );
}

export default AccountIcon;



